const Dialog = (theme) => {
  return {
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '16px',
        },
      },
    },
  };
};

export default Dialog;
